import { accountRequest } from './captureAccount';

export type StudioCamera = 'front' | 'three_quarter' | 'side';
export type StudioPreset = 'studio' | 'courtyard';
export type StudioCollisionPolicy = 'stop' | 'report';
export type StudioArtifact = 'blend' | 'video' | 'report' | 'preview';
export interface AnimationStudioCapabilities {
  enabled: boolean; configured: boolean; development_preview: boolean; preview_credits: number;
  daily_limit: number; max_active: number; max_asset_bytes: number; max_motion_bytes: number;
  durations: number[]; cameras: StudioCamera[]; scene_presets: StudioPreset[];
  collision_policies: StudioCollisionPolicy[]; bvh_scales: number[]; terms_version: string;
}
export interface AnimationStudioJob {
  job_id: string; state: string; stage: string | null; progress: number; created_at: string;
  error: string | null; error_code?: string | null; artifacts_available: boolean; preview_credits: number;
  inputs: {motion: boolean; character: boolean; environment: boolean};
  settings: {duration: number; camera: StudioCamera; scene_preset: StudioPreset; root_motion: boolean;
    collision_policy: StudioCollisionPolicy; bvh_scale?: number; width: number; height: number;
    fps: number; frames: number; source_body_job_id?: string | null};
}
export interface AnimationStudioReport { warnings?: string[]; [key: string]: unknown; }
const jobPath = (id: string) => `animation-studio/jobs/${encodeURIComponent(id)}`;
export const animationStudio = {
  async capabilities(signal?: AbortSignal): Promise<AnimationStudioCapabilities> {
    return (await accountRequest('animation-studio/capabilities', {signal})).json();
  },
  async list(signal?: AbortSignal): Promise<AnimationStudioJob[]> {
    return (await (await accountRequest('animation-studio/jobs', {signal})).json()).jobs;
  },
  async get(id: string, signal?: AbortSignal): Promise<AnimationStudioJob> {
    return (await accountRequest(jobPath(id), {signal})).json();
  },
  async submit(body: FormData, key: string): Promise<AnimationStudioJob> {
    return (await accountRequest('animation-studio/jobs', {method: 'POST', body, headers: {'Idempotency-Key': key}})).json();
  },
  async cancel(id: string): Promise<AnimationStudioJob> {
    return (await accountRequest(`${jobPath(id)}/cancel`, {method: 'POST'})).json();
  },
  async artifact(id: string, kind: StudioArtifact, signal?: AbortSignal): Promise<Blob> {
    return (await accountRequest(`${jobPath(id)}/artifacts/${kind}`, {signal})).blob();
  },
  async report(id: string, signal?: AbortSignal): Promise<AnimationStudioReport> {
    return (await accountRequest(`${jobPath(id)}/artifacts/report`, {signal})).json();
  },
};
